export default "__VITE_ASSET__C_Zhhi2K__"